import { sample } from 'effector';
import { $currentCategory, $hsCodes, $worldPolygons } from './stores.js';
import { changeCurrentCategoryEv } from './events.js';
import {
  getABCountriesFx,
  getABCountriesHSDataFx,
  getABHSCodesFx,
} from './effects.js';

$currentCategory.on(changeCurrentCategoryEv, (state, payload) => payload);

// sample({
//   source: $worldPolygons,
//   clock: getABCountriesFx.doneData,
//   fn: (source, clock) => {
//     const test = source.map((item) => {
//       const data = clock.find((elem) => +elem.code === item.properties.id);
//       return {
//         ...item,
//         properties: {
//           name: data?.name_ru || item.properties.name,
//           id: item.properties.id,
//         },
//       };
//     });
//     debugger;
//   },
// });

sample({
  clock: getABHSCodesFx.doneData,
  fn: (clock) => {
    return clock.map((item) => {
      return {
        label: `${item.hscode} - ${item.product_name}`,
        value: item.hscode,
      };
    });
  },
  target: $hsCodes,
});

sample({
  source: $worldPolygons,
  clock: getABCountriesHSDataFx.doneData,
  fn: (source, clock) => {
    return source.map((item) => {
      const data = clock.data.find(
        (elem) =>
          +elem.country_code === item.properties.id &&
          elem.type === 'import_from'
      );
      return {
        ...item,
        properties: {
          ...item.properties,
          ...data,
        },
      };
    });
  },
  target: $worldPolygons,
});

sample({
  clock: $currentCategory.updates,
  target: getABCountriesHSDataFx,
});
